import * as React from 'react';
import AccentIcons from '../../icons/Icons';
import { accentUtils, newGuid } from '../../services/HelperService';
import { AccentComboUnbound } from '../unbound/AccentComboUnbound';
import { ConfiguratorContext } from './ConfigContextProvider';
import { fromInt, toDecimal, useSizeChanged, setSizeChanged, toLength } from './ProductConfiguratorShared';


function getAllowedSizes(value) {
    return JSON.parse(value);
}
//metric only
export const ConfigSizeAllowed = React.memo(props => {

    const ctx = React.useContext(ConfiguratorContext);
    const orderLine = ctx.config.OrderLine;

    const baseUnit = ctx.config?.Data?.BaseUnit;
    const precision = ctx.config?.Data.ProductPrecision;


    const sizeChanged = useSizeChanged(accentUtils.getEmptyGuid(), `ConfigSizeAllowed_${props.width}`);

    const data = React.useRef(props.sizes.map(s => ({ ID: s, Value: s.toString() })));


    const onChange = React.useCallback(e => {


        var lengthValue = toLength(e ?? 0, baseUnit??10);

        if (props.width) {
            orderLine.Width = lengthValue;
        } else {
            orderLine.Height = lengthValue;
        }

        setSizeChanged(ctx);
        

    }, [ctx, orderLine, props, baseUnit]);


    const showMore = false;

    //metric only
    const value = props.width ? fromInt(orderLine.Width?.Value) : fromInt(orderLine.Height?.Value);

    

    return <div className="config-size-single d-flex">
        <div>
            <AccentComboUnbound
                key={sizeChanged.changeID}
                defaultValue={value}
                displayField="Value"
                valueField="ID"
                onChange={onChange}
                required
                disabled={props.readOnly}
                data={data.current}
                openOnFocus
                hideClear={props.small}
                popupClassName="config-popup"
            />
        </div>
        {showMore && <div>
            <AccentIcons.More />
        </div>}
    </div>;
});